import {
  DEFAULT_LOOK,
  FACE_IDS,
  FIGURE_IDS,
  HAT_IDS,
  isFreeItem,
  isShopItem,
  type Avatar,
  type AvatarItemId,
  type FaceId,
  type FigureId,
  type HatId,
  type ShopItem,
  type Wardrobe,
} from '@pixelworld/shared';

/** What the profile page starts from before the player has ever chosen. */
export const STARTING_AVATAR: Avatar = {
  figure: 'adventurer',
  hat: null,
  face: null,
  look: { ...DEFAULT_LOOK },
};

/** Everything to try on, in catalog order, with going without a hat or face thing first. */
export const AVATAR_CHOICES = {
  figures: FIGURE_IDS as readonly FigureId[],
  hats: [null, ...HAT_IDS] as readonly (HatId | null)[],
  faces: [null, ...FACE_IDS] as readonly (FaceId | null)[],
};

export function isOwned(owned: readonly AvatarItemId[], item: AvatarItemId): boolean {
  return isFreeItem(item) || owned.includes(item);
}

/** The first thing tried on that has to be bought before it can be worn: figure, hat, face. */
export function firstToBuy(owned: readonly AvatarItemId[], choice: Avatar): ShopItem | null {
  for (const item of [choice.figure, choice.hat, choice.face]) {
    if (item && !isOwned(owned, item) && isShopItem(item)) return item;
  }
  return null;
}

/** Whether the choice differs from what the profile has saved. */
export function isChanged(wardrobe: Wardrobe, choice: Avatar): boolean {
  const saved = wardrobe.avatar;
  if (!saved) return true;
  return (
    saved.figure !== choice.figure ||
    saved.hat !== choice.hat ||
    saved.face !== choice.face ||
    (Object.keys(choice.look) as (keyof Avatar['look'])[]).some(
      (part) => saved.look[part] !== choice.look[part],
    )
  );
}
